import ActionTypes from '../../actionTypes'
const { GET_ALL_DATA_FAIL, GET_ALL_DATA_SUCCESS } = ActionTypes.REPORTS.HISTORIC_DETAILS

const initialState = {
  allHistoricDetails: [],
  dataCount: 0,
}

const historicDetailsReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case GET_ALL_DATA_SUCCESS:
      return {
        ...state,
        allHistoricDetails: payload.rows,
        dataCount: payload.count,
      }
    case GET_ALL_DATA_FAIL:
      return {
        ...state,
        allHistoricDetails: [],
        dataCount: 0,
      }
    default:
      return state
  }
}

export default historicDetailsReducer
